<template>
	<div class="ks-videoeditor-track-head" :class="{active: active}" :style="{width: width + 'px'}" title="Drag to reorder" @mousedown.prevent="$emit('drag-start', $event)">
		<input v-if="editing" ref="name_input" v-model="editing_name" class="ks-videoeditor-track-name-input" @mousedown.stop @click.stop @keydown.enter.stop.prevent="finish_rename(true)" @keydown.esc.stop.prevent="finish_rename(false)" @blur="finish_rename(true)">
		<span v-else class="ks-videoeditor-track-name" title="Double-click to rename" @dblclick.stop="start_rename">{{ track.name }}</span>
		<span class="ks-videoeditor-track-actions">
			<span v-if="track.kind != 'audio'" class="ks-videoeditor-track-eye" :title="track.hidden ? 'Show track' : 'Hide track'" @mousedown.stop @click.stop="$emit('toggle-hidden')"><span class="material-icons">{{ track.hidden ? 'visibility_off' : 'visibility' }}</span></span>
			<span v-if="track.kind != 'overlay'" class="ks-videoeditor-track-eye" :class="{off: track.muted}" :title="track.muted ? 'Unmute track' : 'Mute track'" @mousedown.stop @click.stop="$emit('toggle-mute')"><span class="material-icons">{{ track.muted ? 'volume_off' : 'volume_up' }}</span></span>
			<span v-if="removable" class="ks-videoeditor-track-x" title="Remove track" @mousedown.stop @click.stop="$emit('remove')">&times;</span>
		</span>
	</div>
</template>

<script>
// Left-hand header of a track row: name (double-click to rename), hide/mute toggles and remove
export default {
	props: {
		track: Object,
		width: Number,
		// The track new items are added to
		active: Boolean,
		removable: Boolean
	},
	data () {
		return {
			editing: false,
			editing_name: ""
		}
	},
	methods: {
		start_rename () {
			this.editing = true;
			this.editing_name = this.track.name;
			this.$nextTick(() => {
				const input = this.$refs.name_input;
				if (input) {
					input.focus();
					input.select();
				}
			});
		},
		finish_rename (save) {
			if (!this.editing) return;
			const name = this.editing_name.trim();
			this.editing = false;
			if (save && name) this.$emit("rename", name);
		}
	}
}
</script>
